<script>
  import options from './DirectMessagesContent.options'
  export default options
</script>

<template>
  <article class="kb-direct-messages-content kb-direct-messages-content--big-screens">
    
    <div class="kb-direct-messages-content__left-wrapper">
      <DirectMessageNavigation :guid="guid" :userData="userData" />
    </div>
    <div class="kb-direct-messages-content__right-wrapper">
      <DirectMessageThread :chatId="chatId" :userData="userData" />
    </div>

  </article>

  <article class="kb-direct-messages-content kb-direct-messages-content--smaller-screens">

    <div class="kb-direct-messages-content__left-wrapper">
      <DirectMessageThread :chatId="chatId" :userData="userData" />
    </div>
    <div class="kb-direct-messages-content__right-wrapper">
      <DirectMessageNavigation :guid="guid" :userData="userData" />
    </div>

  </article>
  
</template>
